import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PriceAmounts } from '@sm360/widget-commons-general';
import { Incentives } from '@sm360/widget-commons-tiles';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

import './Rebate.scss';

class Rebate extends React.Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    renderIncentiveTotal(incentives) {
        return (
            incentives.total > 0 && (
                <div className="vehicle-tile-rebate-single vehicle-best-rebate">
                    <icon className="icon-promo2 is-price" />
                    <span>
                        {LocaleService.t('VEHICLE_STATUS.REBATE_BEFORE')}{' '}
                        <PriceAmounts price={LocaleService.l(incentives.total, CurrencyFormats.CURRENCY_0)} />{' '}
                        {LocaleService.t('VEHICLE_STATUS.REBATE_AFTER')}
                    </span>
                </div>
            )
        );
    }

    /* eslint-disable react/display-name */
    renderElectricRebate(incentives) {
        return (
            incentives.electricRebateIncluded && (
                <div className="vehicle-tile-rebate-single vehicle-electric-rebate">
                    <icon className="icon-electric-vehicle sr-sucessColor" />
                    <span>{LocaleService.t('VEHICLE_STATUS.ELECTRIC_REBATE')}</span>
                </div>
            )
        );
    }

    render() {
        return (
            <div className="vehicle-tile-rebate">
                {this.renderIncentiveTotal(this.props.incentives)}
                {this.renderElectricRebate(this.props.incentives)}
            </div>
        );
    }
}

Rebate.propTypes = {
    incentives: PropTypes.instanceOf(Incentives).isRequired,
};

Rebate.displayName = 'Rebate';

export default Rebate;
